<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees>

	<div *ngIf="bonCommande" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ bonCommande.commande + ' ' + bonCommande.marche }}</span
					>
				</div>

				<div class="mb-5">
					<a
						class="btn theme-green-button px-4 my-2 mx-2"
						(click)="downloadSynthesis()"
					>
						<span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
						Télécharger la synthèse
					</a>
					<a
						*ngIf="isDeletable"
						(click)="openModal(deleteBonCommande)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="marche" class="form-label fw-bold"
							>N° commande</label
						>
						<span class="form-control-plaintext">{{
							bonCommande?.commande
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="marche" class="form-label fw-bold"
							>Marché</label
						>
						<span class="form-control-plaintext">{{
							bonCommande?.marche
						}}</span>
					</div>
					<div *ngIf="bonCommande.description" class="col-12 col-lg-6">
						<label for="description" class="form-label fw-bold">Description</label>
						<span class="form-control-plaintext" id="description">{{
							bonCommande.description
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="lot" class="form-label fw-bold"
							>Lot</label
						>
						<span class="form-control-plaintext">{{
							bonCommande?.lot
						}}</span>
					</div>
					<div class="col-12 col-lg-6">
						<label for="descriptionLot" class="form-label fw-bold">Description lot</label>
						<span class="form-control-plaintext" id="descriptionLot">{{
							bonCommande.descriptionLot
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="dateDebut" class="form-label fw-bold"
							>Date de début</label
						>
						<span class="form-control-plaintext">{{
							bonCommande?.dateDebut | date : 'dd/MM/yyyy'
						}}</span>
					</div>
					<div class="col-12 col-lg-6">
						<label for="dateFin" class="form-label fw-bold">Date de fin</label>
						<span class="form-control-plaintext" id="dateFin">{{
							bonCommande.dateFin | date : 'dd/MM/yyyy'
						}}</span>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-12 col-lg">
						<label for="service" class="form-label fw-bold"
							>Services</label
						><br/>
						<span
							*ngFor="let exp of bonCommande.services; let ilast = last"
							class="me-1"
						>
							{{ exp && ' ' + exp.service.name }}{{ exp && (ilast ? '' : ',') }}
						</span>
					</div>

					<div class="col-12 col-lg">
						<label for="region" class="form-label fw-bold"
							>Région</label
						>
						<span class="form-control-plaintext">{{
							bonCommande?.region?.name
						}}</span>
					</div>

				</div>
			</div>


			<app-bonCommande-form
				*ngIf="!isFormReadOnly"
				[bonCommande]="bonCommande"
				[isAddForm]="false"
				[form]="form"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			>
			</app-bonCommande-form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm()"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!form.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<div class="row my-5">
		<span class="theme-main-color fw-bold fs-5"
			>Suivi</span
		>
	</div>
	<div class="my-2">
		<div class="col-lg-5 col-10">Volume horaire total : 
			<span class="align-middle">
				{{  calculateVolumeHoraireTotal(bonCommande) }}
				heures 
			</span>
			<div *ngFor="let service of bonCommande?.services">
				<span>{{service.service?.name}} : {{calculateVolumeHoraireBdcByService(calculateVolumeHoraireTotal(bonCommande), service)}} heures </span>
			</div>
		</div>
		<br/>
		<!-- <div class="col-lg-5 col-10">Volume horaire prévisionnel : 
			<span class="align-middle">
				{{  calculateVolumeHorairePrevByBdc() }}
				heures 
				(
				{{calculateVolumeHorairePercent(calculateVolumeHoraireTotal(bonCommande), calculateVolumeHorairePrevByBdc())}} %)
				<div *ngFor="let service of bonCommande?.services">
					<span>{{service.service?.name}} : {{calculateVolumeHorairePrevByService(service?.service)}} heures </span>
				</div>
			</span>
		</div> -->
		<br/>
		<div
			*ngFor="
				let reference of bonCommande?.references
					| paginate : { itemsPerPage: 5, currentPage: currentPage }
			"
			class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
		>
			<div class="col-lg-2 col-10">Référence: 
				<span class="align-middle">{{
					reference.reference
				}}</span>
			</div>
			<div class="col-lg-3 col">
				<span class="align-middle">Cible: 
					{{ CibleStringEnum[reference.cible] }}
				</span>
			</div>
			<div class="col-lg-3 col">
				<span class="align-middle">Volume horaire à allouer: 
					{{ reference.quantite }} heures
					<div *ngFor="let serv of bonCommande.services">
						<span>{{serv.service.name}} : {{calculateVolumeHoraireBdcByService(reference.quantite, serv)}} heures </span>
					</div>
				</span>
			</div>
			<div class="col-lg-3 col">
				<span class="align-middle">Volume horaire utilisé: 
					{{ calculateVolumeHoraireRef(reference) }} heures (
					{{calculateVolumeHorairePercent(reference.quantite, calculateVolumeHoraireRef(reference)) }}
					%)
					<div *ngFor="let serv of bonCommande.services">
						<span>{{serv.service.name}} : {{calculateVolumeHoraireRefByService(serv.service, reference)}} heures </span>
					</div>
				</span>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			></pagination-controls>
		</div>
	</div>

	<ng-template #deleteBonCommande>
		<div class="modal-header text-center">
			<h4>Suppression {{ labelBonCommandeCapitalized }}</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(bonCommande)"
				>Supprimer</a
			>
		</div>
	</ng-template>
</div>
